import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { StoreContext } from 'store/context'

import NewLoginComponent from './component'

export default combine(
  withContext('auth', StoreContext, ({ auth }) => auth),
  withCallbacks({
    onSubmit:
      ({ auth }) =>
      ({ email, password }) =>
        auth.login(email, password),
  })
)(NewLoginComponent)
